﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import PoweredByConsilio from "~base/Components/Composite/PoweredByConsilio";
import { SplashPage } from "~base/Components/Pages/Shared/SplashPage";
import { useAdditionalStyles } from "./Styles";
import { SplashContent } from "~base/Components/Pages/Shared/SplashContent";
import TextBlock from "~base/Components/Primitives/TextBlock";
import Button from "~base/Components/Primitives/Button";
import { useSearchParams } from "react-router-dom";
import { useSettings } from "~base/Settings/SettingsContext";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

type EndSessionProps = unknown;

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

export const EndSessionPage: React.FunctionComponent<EndSessionProps> = (
    props: EndSessionProps
) => {
    const classes = useAdditionalStyles();
    const settings = useSettings();

    React.useEffect(() => {
        window.close();
    }, []);

    const serverVirtualPath = settings.valueAsString("serverVirtualPath");

    const [searchParams] = useSearchParams();
    const completeVal =
        searchParams.get("complete") ?? searchParams.get("Complete");
    const url = `${serverVirtualPath}Home/EndSession?Complete=${completeVal}&Redirect=true`;

    return (
        <SplashPage isLoading={false} showSplashScreen={false}>
            <SplashContent
                header={
                    <TextBlock
                        text={"Tillbaka till min sida"}
                        cssClass={classes.header}
                    />
                }
                footer={
                    <Button
                        onClick={() => {
                            window.location.href = url;
                        }}
                    >
                        Min sida
                    </Button>
                }
            >
                <TextBlock
                    size={"Small"}
                    styleType={"Paragraph"}
                    text={
                        "Rådgivningstjänsten har öppnats i en separat flik. Stäng fönstret för att återgå till min sida."
                    }
                />
            </SplashContent>
            <PoweredByConsilio />
        </SplashPage>
    );
};
